import { render, staticRenderFns } from "./addMaterial.vue?vue&type=template&id=b6bb0678&scoped=true"
import script from "./addMaterial.vue?vue&type=script&lang=js"
export * from "./addMaterial.vue?vue&type=script&lang=js"
import style0 from "./addMaterial.vue?vue&type=style&index=0&id=b6bb0678&prod&lang=less&scoped=true"
import style1 from "./addMaterial.vue?vue&type=style&index=1&id=b6bb0678&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6bb0678",
  null
  
)

export default component.exports